import { Component, OnInit } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-infringement-types',
    templateUrl: './infringement-types.component.html',
    styleUrls: ['./infringement-types.component.scss'],
    standalone: false
})
export class InfringementTypesComponent implements OnInit {

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Id', 'Id'),
    new Datalistviewcolumn('Name', 'Name'),
    new Datalistviewcolumn('Base Fine', 'BaseFine'),
    new Datalistviewcolumn('Active', 'IsActive'),
    new Datalistviewcolumn('Appeal Eligible', 'AppealEligible')
  ];

  constructor() { }

  async ngOnInit(): Promise<void> {
  }
}


